export type UiDensity = 'compact' | 'comfortable';

export const densityTokens = {
  compact: {
    controlHeight: 32,
    tableRowHeight: 36,
    toolbarGap: 8,
    sectionGap: 16,
    verticalSpacing: 'xs' as const,
  },
  comfortable: {
    controlHeight: 36,
    tableRowHeight: 44,
    toolbarGap: 12,
    sectionGap: 24,
    verticalSpacing: 'sm' as const,
  },
} as const;

/** Default density for data-heavy operational screens. */
export const defaultDensity: UiDensity = 'compact';
